import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="text-center">
            <h1>404 page not Found</h1>
            <Link to="/"><button className="button">Go Back</button></Link>
        </div>
    );
};

export default NotFound;